import React, { useCallback, useState } from "react";
import AuthTextInput from "../../components/common/commonTextInputs/authTextInput";
import bgImg from "../../assets/images/bgImg.png";
import SidebarLogo from "../../assets/logos/Awesome! Events Logo.png";
import AuthButton from "../../components/common/commonButtons/authButton";
import { useNavigate } from "react-router-dom";
import profileimg from "../../assets/svg/person_24px.svg";
import { LoginErrorState, loginState } from "../../interface/types";
import { loginConfig } from "../../resources/constants";
import { loginDetails } from "../../redux/slices/authSlice";
import { useDispatch } from "react-redux";
import { Cookie } from "../../hooks/useStorage";
import Cookies from "js-cookie";
import { loginAPI } from "../../services/authServices";
import { useEnterKey } from "../../utils/helperData";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [login, setLogin] = useState<loginState>({
    email: "",
    password: "",
    remember: false,
    showPass: false,
    togglePass: false,
    LoggedIn: false,
    errors: false,
    errorMessage: {
      emailError: "",
      passWordError: "",
      validationError: "",
    },
  });
  const [error, setErrors] = useState<LoginErrorState>({
    email: false,
    password: false,
    wholeError: false,
  });
  const [loading, setLoading] = useState<boolean>(false);

  const handleForgot = () => {
    navigate("/forgot");
  };

  const onChangeInput = useCallback((e: any) => {
    const { name, value } = e.target;
    if (name === "email") {
      setLogin((prev: any) => ({ ...prev, [name]: value.toLowerCase() }));
    } else {
      setLogin((prev: any) => ({ ...prev, [name]: value }));
    }

    setErrors((prev: any) => ({
      ...prev,
      email: false,
      password: false,
      wholeError: false,
    }));
  }, []);


  // Add this function to get the user's location
  const getCurrentLocation = (): Promise<string> => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation is not supported by your browser"));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const { latitude, longitude } = position.coords;
            // Use a reverse geocoding service to get the city name
            const response = await fetch(
              `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
            );
            const data = await response.json();
            resolve(data.city || data.locality || "Unknown location");
          } catch (error) {
            console.error("Error getting location:", error);
            resolve("Unknown location");
          }
        },
        (error) => {
          console.error("Error getting location:", error);
          resolve("Unknown location");
        }
      );
    });
  };

  const sigin = useCallback(async () => {
    console.log("sigin button trigger");
    if (loading) return; // ✅ prevents multiple clicks
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // check both email and password empty
    if (!login.email && !login.password) {
      setErrors((prev: any) => ({ ...prev, wholeError: true }));
      setLogin((prev: any) => ({
        ...prev,
        errorMessage: {
          ...prev.errorMessage,
          validationError: loginConfig().BLANK_VALIDATION,
        },
      }));
      return;
    }

    // check email is empty
    if (!login.email) {
      setErrors((prev: any) => ({ ...prev, email: true }));
      setLogin((prev: any) => ({
        ...prev,
        errorMessage: {
          ...prev.errorMessage,
          emailError: loginConfig().EMAIL_BLANK,
        },
      }));
      return;
    }
    // check email is valid or not
    if (!emailRegex.test(login.email)) {
      setErrors((prev: any) => ({ ...prev, email: true }));
      setLogin((prev: any) => ({
        ...prev,
        errorMessage: {
          ...prev.errorMessage,
          emailError: "Enter a valid Email address",
        },
      }));
      return;
    }
    // check password is empty
    if (!login.password) {
      setErrors((prev: any) => ({ ...prev, password: true }));
      setLogin((prev: any) => ({
        ...prev,
        errorMessage: {
          ...prev.errorMessage,
          passWordError: loginConfig().BLANK_PASSWORD,
        },
      }));
      return;
    }

    // setLoading(true);

    try {
      const location = await getCurrentLocation();
      const userObject = {
        email: login.email,
        password: login.password,
        location: location || "Unknown Location" // Add the location to the payload
      };
      setLoading(true);

      const value: any = await loginAPI(userObject);
      if (value?.token) {
        console.log("Login Successful");
        Cookies.set("access_token", value?.token,  { expires: 1 } );
        Cookies.set("email", value.email, { expires: 1 });
        Cookies.set("ur", "1", { expires: 1 });
        Cookies.set("userId", value.userId, { expires: 1 });
        Cookies.set("role", value.role, { expires: 1 });
        Cookies.set("role_id", value.role_id, { expires: 1 });

        dispatch(
          loginDetails({
            loginUserDetails: value,
          })
        );

        navigate("/dashboard", {
          state: { roleId: value?.userId },
        });
        // navigate("/user-list");
      } else if (value?.statusCode === 401) {
        setErrors((prev: any) => ({ ...prev, wholeError: true }));
        setLoading(false);
        setLogin((prev: any) => ({
          ...prev,
          errorMessage: {
            ...prev.errorMessage,
            validationError: value?.message || loginConfig().WRONG_USER,
          },
        }));
      } else {
        setErrors((prev: any) => ({ ...prev, wholeError: true }));
        setLoading(false);
        setLogin((prev: any) => ({
          ...prev,
          errorMessage: {
            ...prev.errorMessage,
            validationError: loginConfig().WRONG_USER,
          },
        }));
      }

      // if(login.email === "abc@gmail.com" && login.password === "abc123" ){
      //   console.log("Login successfull");

      //   navigate("/home/dashboard");
      // }
      // else{
      //   setErrors((prev: any) => ({ ...prev, wholeError: true }));
      //   setLogin((prev: any) => ({
      //         ...prev,
      //         errorMessage: {
      //           ...prev.errorMessage,
      //           validationError:
      //              loginConfig().WRONG_USER,
      //         },
      //       }));
      // }

      /---------------------------------------------------------------------------/;

      // const value: any = await loginAPI(userObject);
      // if (value?.status_code === 200) {
      //   const { user: LoginUserDetails, token: TokenDetails } = value.data;
      //   setLogin((prev: any) => ({ ...prev, LoggedIn: false }));

      //   dispatch(
      //     loginDetails({
      //       token: TokenDetails,
      //       loginUserDetails: LoginUserDetails,
      //     })
      //   );

      //   // Set cookies
      //   Cookies.set("access_token", TokenDetails?.accessToken, 7);
      //   Cookies.set("logindetails", JSON.stringify(LoginUserDetails), 7);

      //   setTimeout(() => {
      //     setLoading(false);
      //     navigate("/home/dashboard");
      //     console.log("Login Successful");
      //   }, 1000);
      // } else if (value?.status_code === 401) {
      //   setLogin((prev: any) => ({
      //     ...prev,
      //     errorMessage: {
      //       ...prev.errorMessage,
      //       validationError:
      //         value?.message || loginConfig().AUTHENTICATION_FAILED,
      //     },
      //   }));
      //   setLoading(false);
      //   setErrors((prev: any) => ({ ...prev, wholeError: true }));
      // } else if (value?.status_code === 424) {
      //   setLogin((prev: any) => ({ ...prev, LoggedIn: true }));
      // } else {
      //   setLogin((prev: any) => ({
      //     ...prev,
      //     errorMessage: {
      //       ...prev.errorMessage,
      //       validationError:
      //         value?.message || loginConfig().AUTHENTICATION_FAILED,
      //     },
      //   }));
      //   setLoading(false);
      //   setErrors((prev: any) => ({ ...prev, wholeError: true }));
      // }
    } catch (e: any) {
      // setLogin((prev: any) => ({
      //   ...prev,
      //   errorMessage: {
      //     ...prev.errorMessage,
      //     validationError:
      //       e?.response?.data?.message ?? loginConfig().AUTHENTICATION_FAILED,
      //   },
      // }));
      setLoading(false);
      setErrors((prev: any) => ({ ...prev, wholeError: true }));
    }
  }, [login, navigate]);

  useEnterKey(sigin);

  return (
    <>
      <div
        className="flex justify-center items-center w-[100%] h-screen bg-cover bg-center text-white"
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="!w-[400px] flex justify-center items-center !py-[2rem] bg-authContainerBg border border-authContainerBg !rounded-2xl">
          <div className="!m-[1rem] w-[75%] flex flex-col justify-center items-center">
            <img
              src={SidebarLogo}
              alt="Awesome Events"
              className="!mb-[1rem] w-[11rem] h-auto"
            />
            <p className="font-semibold text-[1.5rem]">Welcome Back !</p>
            <p className="text-[0.8rem] !mb-[1rem]">Log in to continue</p>
            <div className="relative w-[100%]">
              <AuthTextInput
                types={"email"}
                name="email"
                onChange={onChangeInput}
                autoFocus={true}
                placeholder="Enter your email"
                icon={profileimg}
              />
              {error.email && (
                <p className="absolute text-[0.7rem] text-red-500">
                  {" "}
                  {login.errorMessage.emailError}
                </p>
              )}
            </div>

            <div className="relative w-[100%]">
              <AuthTextInput
                placeholder="Password"
                types="password"
                name="password"
                onChange={onChangeInput}
              />
              {error.password && (
                <p className="absolute text-[0.8rem] text-red-500">
                  {" "}
                  {login.errorMessage.passWordError}
                </p>
              )}
            </div>
            <button
              type="button"
              className="text-end text-[0.8rem] !mt-[1rem] cursor-pointer text-primaryColor self-end"
              onClick={handleForgot}
            >
              Forgot Password?
            </button>
            {error.wholeError && (
              <p className="text-[0.8rem] text-red-500 text-center">
                {login.errorMessage.validationError}
              </p>
            )}
            <AuthButton
              disabled={loading}
              message={loading ? "Logging ..." : "Login"}
              onClick={sigin}
              classes="bg-gradient-to-r from-[#3BEBAA4D] to-[#3983DD] !font-semibold !text-[0.9rem] !normal-case !text-white w-[100%] !rounded-[5px] h-[2.3rem] !p-[0.9rem] !mt-[1rem]"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
